<template>
  <page-content v-if="hasPermission('report_export')" page-title="Xuất báo cáo kiểm kho">
    <panel title="Nhập thông tin">

      <b-row>
        <b-col>
          <c-date-picker label="từ ngày" v-model="data.fromDate"/>
        </b-col>

        <b-col>
          <c-date-picker label="đến ngày" v-model="data.toDate"/>
        </b-col>
      </b-row>

      <b-row>
        <b-col class="text-center">
<!--          <c-form ref="data" @submit="$refs.table.reload()">-->
            <button class="btn btn-success" type="submit"  @click="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>
<!--          </c-form>-->
        </b-col>
      </b-row>

    </panel>

    <panel title="Kết quả tìm kiếm">
      <c-table ref="table"
               lazy
               :data-filter="dataSearch"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Mã shop'},
                   {text: 'Tên shop'},
                   {text: 'Bưu cục'},
                   {text: 'Tỉnh'},
                   {text: 'sku'},
                   {text: 'Tồn'},
                   {text: 'skuKK'},
                   {text: 'totalKK'},
                   {text: 'ttkk'},
                   {text: 'CL'},
                   {text: 'created_at'},
                   {text: 'approved_at'}
               ]"
               uri="/cms/api/v1.0/report/data"
               @getData="handleGetData"      > <!--lắng nghe sự kiện getData ở component c-table-->
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.maShop }}</td>
          <td>{{ item.tenShop }}</td>
          <td>{{ item.buuCuc }}</td>
          <td>{{ item.tinh }}</td>
          <td>{{ item.sku }}</td>
          <td>{{ item.ton }}</td>
          <td>{{ item.skuKK }}</td>
          <td>{{ item.totalKK }}</td>
          <td>{{ item.ttKK }}</td>
          <td>{{ item.cl }}</td>
          <td>{{ item.createdAt }}</td>
          <td>{{ item.approvedAt }}</td>
        </template>
      </c-table>
    </panel>
    <b-col class="text-right">
      <button class="btn btn-success" v-if="downloadable" @click="downloadItem('ReportInventory.xls')">
        <i class="fas fa-download"></i> Download
      </button>
      <button class="btn btn-secondary" v-else disabled>
        <i class="fas fa-download"></i> Download
      </button>
    </b-col>

  </page-content>
</template>

<script>
export default {
  name: "Index",
  data(){
    return {
      downloadable: false,
      data : {
        fromDate : '',
        toDate : ''
      },
      linkDownload : ''
    }
  },
  computed:{
    dataSearch(){
      return {
        fromDate: this.data.fromDate,
        toDate: this.data.toDate
      }
    }
  },
  methods: {
    submit() {
      // validate input c-date-picker
      if(this.validate(this.data.fromDate,this.data.toDate)) {
        this.$error('Nhập ngày không chính xác');
        this.downloadable = false; // validate ngày sai thì disable nút Download
        this.$root.$emit('dateError');
        return;
      }
      let from = this.convertDateToString(this.data.fromDate);
      let to = this.convertDateToString(this.data.toDate)
      this.$refs.table.reload();
      this.$reportService.get("/v1.0/report/inventory?from_date="+from+"&to_date="+to
      ).then(success => {
        this.$success();
        this.downloadable = true;
        this.linkDownload = success.data.data;
      }).catch(error => {
        this.errorNotify(error)
        .then(error => {
          this.$error(error.response.data.message);
        })
      });
    },
    async downloadItem(label) {
      const axios = require('axios');
      const response = await axios.get(this.linkDownload, { responseType: "blob" });
      const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = label;
      link.click();
      URL.revokeObjectURL(link.href);
      this.downloadable = false;
    },
    convertDateToString(date) {
      let today = date;
      let dd = String(today.getDate()).padStart(2, '0');
      let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
      let yyyy = today.getFullYear();
      today = yyyy + '-' + mm + '-' + dd;
      return today;
    },
    validate(from,to) {
      return from > to;
    },
    handleGetData(data) {
      if (data?.length === 0) {
        this.downloadable = false;
      }
    }
  }
}
</script>

<style scoped>

</style>